import { MenuSub } from '@/components/menu';
import { MegaMenuSubDropdown } from './components';
const MegaMenuSubBilling = items => {
  const billingItem = items.find(
    item => item.title === 'Billing ' || item.title === 'Billing'
  );

  return <MenuSub className="menu-default py-2.5 lg:w-[225px]">
      {billingItem.children && MegaMenuSubDropdown(billingItem.children)}
    </MenuSub>;
};
export { MegaMenuSubBilling };